import { LandingPage } from '../pages/LandingPage';

// Iteration 01 renders the single static landing page directly. The router,
// providers, and app layout (frontend design §16) arrive in later iterations
// once there are authenticated routes to guard.
export function App() {
  return <LandingPage />;
}
